import pxToRem from "../../functions/pxToRem";

export default function textField({ colors }) {
  const { transparent, background } = colors;

  const textField = {
    styleOverrides: {
      root: {
        backgroundColor: transparent.main,

        // Improve spacing for form fields
        "& .MuiFormHelperText-root": {
          marginTop: pxToRem(6),
          marginLeft: pxToRem(2),
          fontSize: pxToRem(12),
          lineHeight: 1.4,
        },

        // Add subtle background on focus
        "& .MuiOutlinedInput-root": {
          backgroundColor: background.paper,

          "&.Mui-focused": {
            backgroundColor: background.paper,
          },
        },
      },
    },
  };

  return textField;
}
